import React from 'react';
import { TabList } from '@hub/tabs';
import { useStoredCentre } from '../../../hooks/use-stored-centre';
import { TabItemList } from './tab-list-item';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HeaderTabs = _ref => {
  let {
    tabsProps,
    sx,
    country
  } = _ref;
  const [storedCentre] = useStoredCentre();
  const nationalUrl = tabsProps.variant === 'centre' ? '/' : undefined;

  if (tabsProps.variant === 'national' && country === 'New Zealand') {
    return null;
  }

  return /*#__PURE__*/_jsx(TabList, {
    sx: sx,
    "data-id": "tabs_header-tabs_HeaderTabs_TabList",
    children: ['gift-cards', 'account'].indexOf(tabsProps.variant) > -1 ? /*#__PURE__*/_jsx(TabItemList, {
      tabName: tabsProps.variant === 'gift-cards' ? 'Gift cards' : 'Account',
      selectedColour: "brand",
      sx: {
        display: 'none'
      },
      "data-id": "tabs_header-tabs_HeaderTabs_TabItemList"
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [country === 'Australia' && /*#__PURE__*/_jsx(TabItemList, {
        tabName: "Shop online",
        selectedColour: "vibrantTeal",
        url: nationalUrl,
        "data-id": "tabs_header-tabs_HeaderTabs_TabItemList_2"
      }), storedCentre && !tabsProps.centre && /*#__PURE__*/_jsx(TabItemList, {
        tabName: "Visit ".concat(storedCentre.title),
        url: "/".concat(storedCentre.slug),
        selectedColour: "brand",
        "data-id": "tabs_header-tabs_HeaderTabs_TabItemList_3"
      }), storedCentre === null && !tabsProps.centre && /*#__PURE__*/_jsx(TabItemList, {
        tabName: 'Visit a centre',
        selectedColour: "brand",
        "data-id": "tabs_header-tabs_HeaderTabs_TabItemList_4"
      }), tabsProps.centre && /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(TabItemList, {
          tabName: tabsProps.centre.title,
          selectedColour: "brand",
          linkUrl: "/".concat(tabsProps.centre.slug),
          "data-id": "tabs_header-tabs_HeaderTabs_TabItemList_5"
        })
      })]
    })
  });
};